(() => {
  const header = document.querySelector('.mah-site-header');

  const closeOpenMenus = (event) => {
    if (!header) return;
    header.querySelectorAll('details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  };
  document.addEventListener('click', closeOpenMenus);

  document.querySelectorAll('.mah-mobile-menu__panel a').forEach((link) => {
    link.addEventListener('click', () => link.closest('.mah-mobile-menu')?.removeAttribute('open'));
  });
})();
